export type SalonBranding = {
  actionColorHex: string;
  lighterColorHex: string | null;
  darkMode: boolean;
};

const DEFAULT_ACCENT = "#8B5CF6";

export function applySalonBranding(branding: SalonBranding | null | undefined): void {
  const root = document.documentElement.style;
  const accent = branding?.actionColorHex ?? DEFAULT_ACCENT;
  root.setProperty("--accent", accent);
  if (branding?.lighterColorHex) {
    root.setProperty("--accent-lighter", branding.lighterColorHex);
  } else {
    root.removeProperty("--accent-lighter");
  }
  document.documentElement.dataset.theme = branding?.darkMode ? "dark" : "light";
}
